import { render, staticRenderFns } from "./CardCameraEmExibicao.vue?vue&type=template&id=ef54c9de&scoped=true"
import script from "./CardCameraEmExibicao.vue?vue&type=script&lang=js"
export * from "./CardCameraEmExibicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef54c9de",
  null
  
)

export default component.exports